function attachSortBy() {
  if (document.querySelector(".sort-by")) {
    queryParams = {};

    if (location.search.length) {
      for (
        var aKeyValue, i = 0, aCouples = location.search.substr(1).split("&");
        i < aCouples.length;
        i++
      ) {
        aKeyValue = aCouples[i].split("=");

        if (aKeyValue.length > 1) {
          queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(
            aKeyValue[1]
          );
        }
      }
    }

    if (document.querySelector(".sort-by")) {
      document.querySelectorAll(".sort-by").forEach(function (select) {
        select.value = select.getAttribute("data-default-value");
        select.dispatchEvent(new Event("change"));
        select.addEventListener("change", function () {
          queryParams.sort_by = this.value;
          location.search = $.param(queryParams).replace(/\+/g, "%20");
        });
      });
    }
  } /// Style any dropdowns
}

function handleResponse(response) {
  console.log(response);
}

let filterContainer = ".cc-collection-products";
let sectionName = "main-collection-products";

function onFilterFormSubmit(filterForm) {
  let currentUrlQuery = new URLSearchParams(window.location.search)
  let data = new FormData(filterForm);
  let queryString = new URLSearchParams(data).toString();

  if( currentUrlQuery.get('view')) {
    queryString += "&view=" + currentUrlQuery.get('view')
  }

  const request = new XMLHttpRequest();
  request.addEventListener("load", handleResponse);
  request.open(
    "GET",
    window.location.pathname + "?" + queryString + "&sections=" + sectionName,
    true
  );
  request.send();

  console.log(
    window.location.pathname + "?" + queryString + "&sections=" + sectionName
  );

  window.history.pushState(
    {},
    null,
    window.location.pathname + "?" + queryString
  );
  request.onload = function () {
    let response = JSON.parse(request.response);
    console.log("response", response);
    let newSection = document.createElement("div");
    newSection.innerHTML = response[sectionName];
    console.log("newSection", newSection);
    document.querySelector(filterContainer).innerHTML =
      newSection.querySelector(filterContainer).innerHTML;
    setTimeout(function () {
      window.initLazyImages();
      attachListeners();
    }, 0);
  };
  return false;
}

function attachListeners() {
  attachSortBy();
  let filterForm = document.querySelector(".filter-form");
  if (filterForm) {
    filterForm.querySelectorAll("input, select").forEach(function (input) {
      input.addEventListener("change", function (ev) {
        ev.preventDefault();
        onFilterFormSubmit(filterForm);
        return false;
      });
    });

    filterForm.addEventListener("submit", function (ev) {
      ev.preventDefault();
      onFilterFormSubmit(filterForm);
      return false;
    });

    let filterGroups = document.querySelectorAll(".filter-group");
    let mobileFilterTrigger = document.querySelector(".mobile-filter-trigger");
    let shadow = document.querySelector(".mobile-filter-shadow");

    document.addEventListener("click", function (e) {
      if (
        e.target == mobileFilterTrigger ||
        mobileFilterTrigger.contains(e.target)
      ) {
        e.stopImmediatePropagation();
        e.preventDefault();
        filterForm.classList.add("active");
      } else if (e.target == shadow || shadow.contains(e.target)) {
        filterForm.classList.remove("active");
      } else if (e.target == filterForm || filterForm.contains(e.target)) {
        //e.stopImmediatePropagation();
        // inside filters
        e.stopImmediatePropagation();
        if (window.innerWidth > 768) {
          if (e.target.closest(".filter-group")) {
            let filterGroup = e.target.closest(".filter-group");

            if (e.target.closest(".filter-group-summary")) {
              filterGroups.forEach(function (group) {
                if (group != filterGroup) {
                  group.classList.remove("active");
                  group.removeAttribute("open");
                }
              });
              filterGroup.classList.toggle("active");
            }
          } else {
            filterGroups.forEach(function (group) {
              group.classList.remove("active");
              group.removeAttribute("open");
            });
          }
        } else {
          if (e.target.closest(".filter-group")) {
            let filterGroup = e.target.closest(".filter-group");
            filterGroup.classList.toggle("active");
          }
        }
      } else {
        filterForm.classList.remove("active");
        filterGroups.forEach(function (group) {
          group.classList.remove("active");
          group.removeAttribute("open");
        });
      }
    });
  }
}

attachListeners();
